export default {
  profileSelector: {
    activeProfile: 'Activă',
  }
}
